import LLGlobeTrekker from '@/locales/GlobeTrekker/fr';
import LLTrendingNow from '@/locales/TrendingNow/fr';
import LLEdito from '@/locales/Edito/fr';
import LLEditoFR from '@/locales/EditoFR/fr';
import LLEditoMC from '@/locales/EditoMC/fr';
import LLEditoCH from '@/locales/EditoCH/fr';
import LLEditoLU from '@/locales/EditoLU/fr';
import LLKumano from '@/locales/Kumano/fr';
import LLCities from '@/locales/Cities/fr';
import LLArty from '@/locales/Arty/fr';
import LLKeyReport from '@/locales/KeyReport/fr';
import LLEntrepreneurs from '@/locales/Entrepreneurs/fr';
import LLGreenEconomy from '@/locales/GreenEconomy/fr';
import LLEssential from '@/locales/Essential/fr';
import LLEssentialFR from '@/locales/EssentialFR/fr';
import LLTheWayISeeIt from '@/locales/TheWayISeeIt/fr';
import LLLegal from '@/locales/Legal/fr';

export const  fr = {

    // les éléments du menu
    // pour l'edito, vu qu'il est variable en fonction du marché (present dans l'url), la structure est un peu différente
    menu: {
        Edito: {
            segment: 'edito',
            title: 'Édito',
        },
        EditoMC: {
            segment: 'edito',
            title: 'Édito',
        },
        EditoCH: {
            segment: 'edito',
            title: 'Édito',
        },
        EditoLU: {
            segment: 'edito',
            title: 'Édito',
        },
        EditoFR: {
            segment: 'edito',
            title: 'Édito',
        },
        Essential: {
            segment: 'les-essentiels',
            title: 'Les essentiels',
        },
        EssentialFR: {
            segment: 'les-essentiels',
            title: 'Les essentiels',
        },
        TheWayISeeIt: {
            segment: 'billet-humeur',
            title: 'Billet d’humeur',
        },
        TrendingNow: {
            segment: 'tendances',
            title: 'Tendances',
        },
        GreenEconomy: {
            segment: 'economie-verte',
            title: 'Économie verte',
        },
        GlobeTrekker: {
            segment: 'globe-trekker-fr',
            title: 'Planète insolite',
        },
        Kumano: {
            segment: 'voyager-differemment',
            title: 'Sur les chemins de Kumano Kodo avec Jérôme Galland',
        },
        Cities: {
            segment: 'ils-pensent-le-futur',
            title: 'Quand la ville devient smart',
        },
        Arty: {
            segment: 'arty',
            title: 'Le monde de Louis Granet',
        },
        KeyReport: {
            segment: 'le-grand-dossier',
            title: 'La finance, un partenaire dans les enjeux climatiques ?',
        },
        Entrepreneurs: {
            segment: 'ils-entreprennent',
            title: 'Rencontre avec Peter Mann Fondateur de Sierentz & Cie',
        },
        Legal: {
            segment: 'informations-legales',
            title: 'Crédits & informations légales',
        },
    },

    // les différentes pages, on scinde en fichiers, sinon ca va être trop long et chiant a contribuer
    Edito: LLEdito,
    EditoFR: LLEditoFR,
    EditoMC: LLEditoMC,
    EditoCH: LLEditoCH,
    EditoLU: LLEditoLU,
    GlobeTrekker: LLGlobeTrekker,
    Kumano: LLKumano,
    TrendingNow: LLTrendingNow,
    GreenEconomy: LLGreenEconomy,
    Essential: LLEssential,
    EssentialFR: LLEssentialFR,
    TheWayISeeIt: LLTheWayISeeIt,
    Cities: LLCities,
    KeyReport: LLKeyReport,
    Arty: LLArty,
    Legal: LLLegal,
    Entrepreneurs: LLEntrepreneurs,

    home: {
        logoBaseLine: 'PB, voir le monde différemment avec Société Générale Private Banking #1',
        title: 'Le monde <br />de Louis <br />Granet',
        artitle3title: 'Le grand dossier',
        artitle3content: 'La finance, un partenaire dans les enjeux climatiques?',
        artitle2title: 'Ils pensent le futur',
        artitle2content:  'Quand la ville devient smart',
        artitle1title: 'Voyager différemment',
        artitle1content:  'Sur les chemins de Kumano Kodo avec Jérôme Galland',
    },

    next: 'À suivre : ',

    welcome_message : 'EN - Welcome to Your Vue.js App',
    popular_links : 'EN - Popular Links',
    ecosystem : 'EN - Ecosystem',
    test: {
        toto: 'toto label',
        tutu: 'tutu label',
        titi: {
            test: 'titi label',
        },
    },
    counterUpSeparator: ' ',
    counterUpDecimal: ',',
};
